/**
 * @generated SignedSource<<f4e681714acc427aa9f721dfc064d88c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraJqlOperator = "CHANGED" | "CONTAINS" | "EQUALS" | "GREATER_THAN" | "GREATER_THAN_OR_EQUAL" | "IN" | "IS" | "IS_NOT" | "LESS_THAN" | "LESS_THAN_OR_EQUAL" | "NOT_CONTAINS" | "NOT_EQUALS" | "NOT_IN" | "WAS" | "WAS_IN" | "WAS_NOT" | "WAS_NOT_IN" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type JQLEditorUIWithErrorBoundary$data = {
  readonly jira?: {
    readonly jqlBuilder: {
      readonly hydrateJqlQuery?: {
        readonly fields?: ReadonlyArray<{
          readonly field?: {
            readonly description: string | null | undefined;
            readonly displayName: string | null | undefined;
            readonly fieldType: {
              readonly displayName: string | null | undefined;
            } | null | undefined;
            readonly operators: ReadonlyArray<JiraJqlOperator>;
            readonly searchTemplate: {
              readonly key: string | null | undefined;
            } | null | undefined;
            readonly shouldExcludeInScope?: boolean | null | undefined;
            readonly shouldShowInContext: boolean | null | undefined;
            readonly type: string | null | undefined;
          };
          readonly jqlTerm?: string;
        }>;
      } | null | undefined;
      readonly hydrateJqlQueryForFilter?: {
        readonly fields?: ReadonlyArray<{
          readonly field?: {
            readonly description: string | null | undefined;
            readonly displayName: string | null | undefined;
            readonly fieldType: {
              readonly displayName: string | null | undefined;
            } | null | undefined;
            readonly operators: ReadonlyArray<JiraJqlOperator>;
            readonly searchTemplate: {
              readonly key: string | null | undefined;
            } | null | undefined;
            readonly shouldExcludeInScope?: boolean | null | undefined;
            readonly shouldShowInContext: boolean | null | undefined;
            readonly type: string | null | undefined;
          };
          readonly jqlTerm?: string;
        }>;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "JQLEditorUIWithErrorBoundary";
};
export type JQLEditorUIWithErrorBoundary$key = {
  readonly " $data"?: JQLEditorUIWithErrorBoundary$data;
  readonly " $fragmentSpreads": FragmentRefs<"JQLEditorUIWithErrorBoundary">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "scope",
  "variableName": "scope"
},
v1 = {
  "kind": "Variable",
  "name": "viewContext",
  "variableName": "viewContext"
},
v2 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v3 = [
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "kind": "LinkedField",
        "name": "fields",
        "plural": true,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "jqlTerm"
              },
              {
                "concreteType": "JiraJqlField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "concreteType": "JiraJqlSearchTemplate",
                    "kind": "LinkedField",
                    "name": "searchTemplate",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "key"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "shouldShowInContext"
                  },
                  {
                    "condition": "isPlanReleaseFeatureToggleEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": [
                          (v0/*: any*/)
                        ],
                        "kind": "ScalarField",
                        "name": "shouldExcludeInScope"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "type"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "description"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "operators"
                  },
                  {
                    "concreteType": "JiraFieldType",
                    "kind": "LinkedField",
                    "name": "fieldType",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/)
                    ]
                  }
                ]
              }
            ],
            "type": "JiraJqlQueryHydratedField"
          }
        ]
      }
    ],
    "type": "JiraJqlHydratedQuery"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "filterAri"
    },
    {
      "kind": "RootArgument",
      "name": "includeJira"
    },
    {
      "kind": "RootArgument",
      "name": "input"
    },
    {
      "kind": "RootArgument",
      "name": "isFilter"
    },
    {
      "kind": "RootArgument",
      "name": "isPlanReleaseFeatureToggleEnabled"
    },
    {
      "kind": "RootArgument",
      "name": "jql"
    },
    {
      "kind": "RootArgument",
      "name": "scope"
    },
    {
      "kind": "RootArgument",
      "name": "viewContext"
    }
  ],
  "kind": "Fragment",
  "name": "JQLEditorUIWithErrorBoundary",
  "selections": [
    {
      "condition": "includeJira",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "cloudId",
                  "variableName": "cloudId"
                }
              ],
              "concreteType": "JiraJqlBuilder",
              "kind": "LinkedField",
              "name": "jqlBuilder",
              "plural": false,
              "selections": [
                {
                  "condition": "isFilter",
                  "kind": "Condition",
                  "passingValue": false,
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "input",
                          "variableName": "input"
                        },
                        {
                          "kind": "Variable",
                          "name": "query",
                          "variableName": "jql"
                        },
                        (v0/*: any*/),
                        (v1/*: any*/)
                      ],
                      "kind": "LinkedField",
                      "name": "hydrateJqlQuery",
                      "plural": false,
                      "selections": (v3/*: any*/)
                    }
                  ]
                },
                {
                  "condition": "isFilter",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "id",
                          "variableName": "filterAri"
                        },
                        (v0/*: any*/),
                        (v1/*: any*/)
                      ],
                      "kind": "LinkedField",
                      "name": "hydrateJqlQueryForFilter",
                      "plural": false,
                      "selections": (v3/*: any*/)
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "3d455073fe3df44f98b0c82ff44bf4b9";

export default node;
